module.exports = __webpack_public_path__ + "static/img/11.b4da14e5.png";